import React, { FC } from "react";
import { Skeleton } from "@mui/material";
import styles from "../../../../features/creditReports/creditReportSummary/CreditReportSummary.module.scss";

/**
 * CreditReportSummarySkeleton Component
 *
 * Displays a loading skeleton for the CreditReportSummary component.
 * Shows placeholder content while the actual data is being fetched.
 */
const CreditReportSummarySkeleton: FC = () => {
  return (
    <div className={styles["credit-report-summary"]} style={{ padding: 0 }}>
      {/* Order ID Skeleton */}
      <div className={styles["credit-report-summary__items"]}>
        <div
          className={styles["credit-report-summary__items__left"]}
          style={{ backgroundColor: "unset" }}
        >
          <Skeleton variant="rectangular" width={100} height={40} />
        </div>
        <div className={styles["credit-report-summary__items__right"]}>
          <Skeleton variant="rectangular" width="60%" height={28} />
          <Skeleton variant="rectangular" width="40%" height={20} />
        </div>
      </div>

      {/* Promotion Name Skeleton */}
      <div className={styles["credit-report-summary__items"]}>
        <div
          className={styles["credit-report-summary__items__left"]}
          style={{ backgroundColor: "unset" }}
        >
          <Skeleton variant="rectangular" width={100} height={40} />
        </div>
        <div className={styles["credit-report-summary__items__right"]}>
          <Skeleton variant="rectangular" width="60%" height={28} />
          <Skeleton variant="rectangular" width="40%" height={20} />
        </div>
      </div>

      {/* Credit Date & Time Skeleton */}
      <div className={styles["credit-report-summary__items"]}>
        <div
          className={styles["credit-report-summary__items__left"]}
          style={{ backgroundColor: "unset" }}
        >
          <Skeleton variant="rectangular" width={100} height={40} />
        </div>
        <div className={styles["credit-report-summary__items__right"]}>
          <Skeleton variant="rectangular" width="60%" height={28} />
          <Skeleton variant="rectangular" width="40%" height={20} />
        </div>
      </div>

      {/* Number of Credits Skeleton */}
      <div className={styles["credit-report-summary__items"]}>
        <div
          className={styles["credit-report-summary__items__left"]}
          style={{ backgroundColor: "unset" }}
        >
          <Skeleton variant="rectangular" width={100} height={40} />
        </div>
        <div className={styles["credit-report-summary__items__right"]}>
          <Skeleton variant="rectangular" width="60%" height={28} />
          <Skeleton variant="rectangular" width="40%" height={20} />
        </div>
      </div>

      {/* Total Credit Value Skeleton */}
      <div className={styles["credit-report-summary__items"]}>
        <div
          className={styles["credit-report-summary__items__left"]}
          style={{ backgroundColor: "unset" }}
        >
          <Skeleton variant="rectangular" width={100} height={40} />
        </div>
        <div className={styles["credit-report-summary__items__right"]}>
          <Skeleton variant="rectangular" width="60%" height={28} />
          <Skeleton variant="rectangular" width="40%" height={20} />
        </div>
      </div>
    </div>
  );
};

export default CreditReportSummarySkeleton;
